import React from 'react'
import { Record, TextField, List } from 'react-admin'
import Typography from '@material-ui/core/Typography'
import { DEFAULT_LIMIT, DEFAULT_SORT_FIELD, DEFAULT_SORT_ORDER } from 'utils/constants'
import { makeStyles } from '@material-ui/styles'
import Datagrid from 'components/MaterialUICore/Datagrid'

type HostInstitutionArchiveConfirmationMessageProps = {
  record: Record
}

const useStyles = makeStyles(theme => ({
  list: {
    '& div:first-child': {
      boxShadow: 'none',
      border: 'none',
      justifyContent: 'center',
      '& span div:first-child>div:first-child': {
        display: 'none',
      },
    },
  },
  noItemsMessage: {
    padding: '30px',
    alignSelf: 'center',
    justifySelf: 'center',
    textAlign: 'center',
  },
  datagrid: {
    '& span[data-field="title"]': {
      'font-weight': 'bold',
    },
  },
}))

const HostInstitutionArchiveConfirmationMessage: React.FC<HostInstitutionArchiveConfirmationMessageProps> = ({
  record,
}) => {
  const classFilter = {
    host_institution: record.id,
  }

  const classes = useStyles()

  return (
    <>
      <Typography data-test="model-confirmation-message">{`Archiving this host institution - ${record.name} - will archive all of it’s associated Classes:`}</Typography>
      <List
        className={classes.list}
        perPage={DEFAULT_LIMIT}
        filter={classFilter}
        sort={{ field: DEFAULT_SORT_FIELD, order: DEFAULT_SORT_ORDER }}
        basePath="/classes"
        hasCreate={false}
        bulkActionButtons={false}
        hasEdit={false}
        exporter={false}
        hasShow={false}
        resource="classes"
        actions={false}
        empty={
          <Typography className={classes.noItemsMessage} data-test="model-confirmation-message-empty">
            There are no Classes associated with this host institution
          </Typography>
        }
      >
        <Datagrid
          hasBulkActions
          className={classes.datagrid}
          empty={<Typography className={classes.noItemsMessage}>Loadding Classes associated...</Typography>}
        >
          <TextField label="Class title" source="title" />
        </Datagrid>
      </List>
    </>
  )
}

export default HostInstitutionArchiveConfirmationMessage
